import { Skirmish } from '../MatchAuthority.js';
import { TeamDeathmatch } from './TeamDeathmatch.js';
import { Domination } from './Domination.js';
import { SearchDestroy } from './SearchDestroy.js';

/**
 * The mode roster.
 *
 * One table, so a screen can list modes without importing each one and `main.js`
 * can restore a saved choice by id. Nothing here imports anything from `ui/` — the
 * label lives with the rules because it is part of what the mode *is*, and the
 * screen that renders it is free to translate it.
 */

export const MODES = [
  {
    id: 'skirmish',
    name: { ja: 'ソロ掃討', en: 'SKIRMISH' },
    blurb: {
      ja: '味方なし。敵だけの波を30体倒す。',
      en: 'No allies. Clear thirty hostiles.',
    },
    make: () => new Skirmish(),
  },
  {
    id: 'tdm',
    name: { ja: 'チームデスマッチ', en: 'TEAM DEATHMATCH' },
    blurb: {
      ja: '6対6。キル1点、先に75点で勝利。',
      en: 'Six a side. One point a kill, first to seventy-five.',
    },
    make: (opts) => new TeamDeathmatch(opts),
  },
  {
    id: 'dom',
    name: { ja: 'ドミネーション', en: 'DOMINATION' },
    blurb: {
      ja: '3拠点を奪い合う。保持数に応じて加点、先に200点。',
      en: 'Three flags. Score per flag held, first to two hundred.',
    },
    make: (opts) => new Domination(opts),
  },
  {
    id: 'snd',
    name: { ja: 'サーチ＆デストロイ', en: 'SEARCH & DESTROY' },
    blurb: {
      ja: 'ラウンド制・リスポーンなし。爆弾を設置するか、全滅させる。',
      en: 'Rounds, one life. Plant the bomb or wipe them out.',
    },
    make: (opts) => new SearchDestroy(opts),
  },
];

export function modeById(id) {
  return MODES.find((m) => m.id === id) ?? MODES[0];
}

/** Build a rules object for an id. Unknown ids fall back to Skirmish, not to a throw. */
export function createRules(id, opts = {}) {
  return modeById(id).make(opts);
}
